import React, {useEffect, useRef} from 'react';
import {Button, Form, Row} from 'react-bootstrap';
import HiddenInput from 'components/Form/HiddenInput';
import Input from 'components/Form/Input';
import MultiCheckboxes from 'components/Form/MultiCheckboxes';

export default function ReportTemplateForm({
    dirty, isValid, isSubmitting, handleSubmit,
    motionTypeOptions, parameterOptions, isDraft, isEditable, isLoading, onCloseClick,
}) {
    const isMounted = useRef(false);
    const isDisabled = !isEditable || !isDraft || isLoading;

    useEffect(() => {
        isMounted.current = true;
        return () => isMounted.current = false;
    }, []);

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Input label="Name" type="text" name="name" required disabled={isDisabled} />
            </Row>
            <Row>
                <Input label="Component type" type="text" name="component_type" disabled={isDisabled} readOnly />
            </Row>
            <Row>
                <MultiCheckboxes label="Motions" name="motion_types" options={motionTypeOptions} disabled={isDisabled} />
            </Row>
            <Row>
                <MultiCheckboxes label="Parameters" name="params" options={parameterOptions} disabled={isDisabled} />
            </Row>
            <HiddenInput name="id" />
            {isEditable && isDraft &&
                <Button type="submit" className="btn-form-submit" disabled={!dirty || !isValid || isSubmitting || isDisabled}>Save</Button>}
            <Button type="button" className="btn-form-close" onClick={onCloseClick} disabled={isSubmitting}>Close</Button>
        </Form>
    )
};
